<template>
  <header class="header">
    <button class="header__trigger" @click="$emit('trigger-menu')">
      <svg-icon name="menu" />
    </button>

    <router-link to="/" class="header__logo">
      <svg-icon name="logo-full" />
    </router-link>
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped lang="scss">
.header {
  padding: 8px 16px;
  background: $alabaster;

  @include md-and-up {
    display: none;
  }

  &__trigger {
    margin-right: 16px;
    transition: 0.3s;

    svg {
      width: 24px;
      height: 24px;
      fill: $luchmara;
    }
  }

  &__logo {
    transition: 0.3s;

    &:hover {
      opacity: 0.8;
    }

    svg {
      width: 88px;
      height: 24px;
    }
  }
}
</style>
